import { SimpleTextCell } from "components/Table/Cells/SimpleTextCell";
import {
  AftermarketPartnerIntegrationSettingsDialogData,
  DealerManagementCellArgs,
  DealerManagementPartnerLink,
} from "modules/aftermarketPartner/types";
import { Column } from "react-table";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { formatCurrency } from "utils";
import { MultiSelectFilter } from "components/Table/Filters/ColumnMultiSelectFilter";
import { searchFilterByColumn } from "components/Table/lib/searchFilters";

export function createTableColumns(
  tableData?: DealerManagementPartnerLink[],
  handleOpenIntegrationSettingsDialog?: (data?: AftermarketPartnerIntegrationSettingsDialogData) => void
): Column<DealerManagementPartnerLink>[] {
  const isNTPAccount = useSelector((state: any) => state.aftermarketPartner.isNTPAccount);

  return [
    {
      Header: "Dealer Name",
      accessor: "accountName",
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.accountName} />,
    },
    {
      Header: "Status",
      accessor: "metrics.status",
      filterable: true,
      filterMethod: searchFilterByColumn,
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.metrics?.status} />,
      Filter: ({ filter, onChange, column }: any) => (
        <MultiSelectFilter filter={filter} onChange={onChange} column={column} rows={tableData || []} />
      ),
    },
    {
      Header: "Active Menus",
      accessor: "metrics.activeMenus",
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.metrics.activeMenus} />,
    },
    {
      Header: "Recent Quotes",
      accessor: "metrics.totalSent",
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.metrics.totalSent} />,
    },
    {
      Header: "Recent Contracts",
      accessor: "metrics.totalSold",
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.metrics.totalSold} />,
    },
    {
      Header: "Sold Volume",
      accessor: "metrics.soldRetailPrice",
      Cell: ({ original }: DealerManagementCellArgs) => (
        <SimpleTextCell formatter={formatCurrency} value={original.metrics.soldRetailPrice} />
      ),
    },
    {
      show: isNTPAccount,
      sortable: false,
      Cell: ({ original }: DealerManagementCellArgs) => (
        <Button size="small" onClick={() => handleOpenIntegrationSettingsDialog!({ partnerLink: original })}>
          Integration Setting
        </Button>
      ),
    },
  ].map(header => ({
    ...header,
    resizable: false,
    headerClassName: "customHeader",
  }));
}
